 export class Project {
project_id: number;
job_name: string;
job_description: string;
job_notes: string;
job_start_date: string;
job_due_date: string;
client_id: number;
creator_user_id: number;
job_summary: string;
status: number;
owner_job_code: string;
client_job_code: string;
name_provided: string;
dob_provided: string;
report_type_id: number;
company_name: string;
payment_status: string;

project_total?;
project_subtotal?;
project_gst?;
project_time_estimate?;
  }
